import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

import { AuthService } from '../security';

@Injectable({ providedIn: 'root' })
export class RedirectEditionCardioGuard implements CanActivate {
    constructor(private authService: AuthService, private router: Router) {}

    canActivate(route: ActivatedRouteSnapshot) {
        const { id } = route.params;
        if (this.authService.canEditMedicalInfos.cardio) {
            this.router.navigate(['edition', id, 'inclusionMode']);
            return true;
        }
        if (this.authService.canEditAdministrativeInfos.cardio) {
            this.router.navigate(['edition', id, 'identity']);
            return true;
        }
        return false;
    }
}
